export default __webpack_public_path__ + "static/media/collaborative-document.3c15f5d4.svg";